import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import HeaderBar from "../../components/headerBar/HeaderBar";
import { t } from "i18next";
import AnswerQuestionDetails from "../../components/answerQuestionDetails/AnswerQuestionDetails";
import { getDefaults } from "react-i18next";
import { getSingleQuestion } from "./api/AnswerQuestionApi";
import { isEmpty } from "../../utils/validation";

const AnswerQuestion = () => {
  const { id_association, id_question } = useParams();

  const [data, setData] = useState([]);

  const refreshContent = () => {
    getSingleQuestion({ id_association, id_question }).then((res) =>
      setData(res)
    );
  };

  useEffect(() => {
    refreshContent();
  }, [id_association, id_question]);

  return (
    <>
      <HeaderBar back={true} title={t("answer_question.title")} />
      <div className="container-responsive pt-3 pb-3 ps-2 pe-2">
        {!isEmpty(data) ? (
          <AnswerQuestionDetails
            id={data.id_question}
            image={
              data.image
                ? "data:" + data.image_type + ";base64," + data.image
                : "/no_img.png"
            }
            name={data.name_association}
            datetime={data.datetime_sending}
            question={data.title}
            answer={data.body}
            refreshContent={refreshContent}
          />
        ) : null}
      </div>
    </>
  );
};

export default AnswerQuestion;
